import { Scale } from "lucide-react";

export const DISCLAIMER = "All plans and drafts are property of Beall Digital Group and cannot be used without written contract under penalty of law.";

export const Disclaimer = ({ compact = false, className = "" }) => (
  <p data-testid={compact ? "disclaimer-compact" : "disclaimer"}
    className={`flex items-start gap-2 text-[var(--muted)] ${compact ? "text-[10px] leading-snug" : "justify-center text-center text-[11px] px-6 py-5 border-t border-[var(--line)] bg-[var(--bg)]"} ${className}`}>
    <Scale size={compact ? 11 : 13} className="shrink-0 mt-0.5 text-[var(--amber)]" />
    <span>{DISCLAIMER}</span>
  </p>
);
